<template>
  <div>
    <!--buzzcast/realive登录页面-->
    <div class="form_box" v-if="!isInBondo">
      <div class="form_item">
          <div class="fc-flex fc-flex-vcenter" @click="selAreaFun">
            <!--国旗logo-->
            <img class="flag_icon" :src="selCountry.logo" alt="">
            <!--国家区号-->
            <span class="fc-text-sm fc-pad-lr-min">+{{selCountry.countryNum}}</span>
            <!--下拉箭头-->
            <img class="select_icon" src="../../assets/img/down.png" alt="">
          </div>
          <!--手机号输入框-->
          <input class="form_input" v-model="phonenum" type="text" :placeholder="$t('m.input_phone_num')"/>
      </div>
      <div class="form_item">
          <!--密码logo(锁)-->
          <img class="form_icon" src="../../assets/img/h5_login_password.png" alt="">
          <!--密码输入框-->
          <input class="form_input" v-model="password" :type="isPassword?'password':'text'" :placeholder="$t('m.input_password')">
          <!--密码的显示/隐藏-->
          <img class="sendcode_img" :src="isPassword?require('../../assets/img/h5_login_eye01.png'):require('../../assets/img/h5_login_eye02.png')" @click="isPassword = !isPassword">
      </div>
      <div class="fc-bind-btn" :class="{ active: formIsTrue }" @click="goLogin">{{$t('m.login')}}</div>
    </div>
    <!--bondo登录页面-->
    <div class="login-phone-bondo" v-if="isInBondo">
      <!--手机号填写区域-->
      <div class="bondo-form_item bondo-form__phone">
        <!--左边区域-->
        <div class="bondo-phone-left" @click="selAreaFun">
          <!--国旗-->
          <img class="bondo-flag_icon" :src="selCountry.logo" alt="">
          <!--区号-->
          <div class="bondo-phone__code">+{{selCountry.countryNum}}</div>
          <!--下拉箭头-->
          <img class="select_icon bondo-phone__down" src="../../assets/img/down_white.png" alt="">
        </div>
        <!--右边区域：输入框-->
        <div class="bondo-phone-right">
          <input class="bondo__input" v-model="phonenum" type="text" :placeholder="$t('m.input_phone_num')" />
        </div>
      </div>
      <!--密码输入区域-->
      <div class="bondo-form_item">
        <!--密码输入框-->
        <input class="bondo__input" v-model="password" :type="isPassword ? 'password' : 'text'" :placeholder="$t('m.input_password')">
        <!--密码的显示/隐藏-->
        <img class="bondo-pwd__visible" :src="isPassword ? require('../../assets/img/hide.png') : require('../../assets/img/show.png')" @click="isPassword = !isPassword">
      </div>
      <!--登录按钮-->
      <div class="bondo-login" :class="{ 'bondo-login__active': formIsTrue }" @click="goLogin">{{$t('m.login')}}</div>
      <!--邮箱登录-->
      <div class="bondo-other" @click="emailLogin">
        <img class="bondo-other__img" src="../../assets/img/email_white.png" />
      </div>
    </div>
    <div class="login_box" v-if="!isTgWebApp">

      <div class="login_other">
        <!-- <login-sdk-apple /> -->
        <login-sdk-facebook styleType="circle" v-if="isInBuzzCast"/>
        <login-sdk-google styleType="circle" v-if="isInBuzzCast"/>
        <login-sdk-twitter v-if="thisLangcountry!=='zh' && isInBuzzCast" />
        <login-sdk-vk v-if="thisLangcountry=='ru' && isInBuzzCast" />
        <login-sdk-instagram v-if="thisLangcountry!=='zh' && isInBuzzCast" />
        <!-- <login-sdk-line v-if="thisLangcountry!=='zh'&&thisLangcountry!=='ru'" /> -->
        <div class="img_box" @click="emailLogin" v-if="!isInBondo">
          <img class="login_other_img" src="../../assets/img/h5_login_icon06.png" />
        </div>
      </div>
    </div>
     <van-popup
      v-model="showCountry"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <selarea />
     </van-popup>
  </div>
</template>
<script>
var _self;
 import Vue from 'vue';
  import { Toast,popup,Cell, CellGroup } from 'vant';
  Vue.use(Toast);
  Vue.use(popup);
  Vue.use(Cell);
  Vue.use(CellGroup);

  import LoginSdkFacebook from './LoginSdk/LoginSdkFacebook';
  import LoginSdkGoogle from './LoginSdk/LoginSdkGoogle';
  import LoginSdkTwitter from './LoginSdk/LoginSdkTwitter';
  import LoginSdkInstagram from './LoginSdk/LoginSdkInstagram';
  import LoginSdkApple from './LoginSdk/LoginSdkApple';
  import LoginSdkVK from './LoginSdk/LoginSdkVK';
  import LoginSdkLine from './LoginSdk/LoginSdkLine';
  import { myMixin } from "@/tools/mixins.js";
  import multiDomain from "../../mixins/multiDomain";
  import { getCountryMsgAjax } from '../../api/index';
import { isTelegramWebApp } from '../../util';
export default {
  name: "LoginPhone",
   mixins: [myMixin, multiDomain],
  components:{
    "login-sdk-facebook":LoginSdkFacebook,
    "login-sdk-google":LoginSdkGoogle,
    "login-sdk-twitter":LoginSdkTwitter,
    "login-sdk-instagram":LoginSdkInstagram,
    "login-sdk-apple":LoginSdkApple,
    "login-sdk-vk":LoginSdkVK,
    "login-sdk-line":LoginSdkLine,
  },
  props: {
    thisLangcountry:{
      type:String,
      default:function(){
        return "en"
      }
    }
  },
  data() {
    return {
      thisLang:'en',
      showCountry: false,//是否显示国家地区
      isPassword:true, //是否显示密码
      formIsTrue:false, //表单是否输入完整
      phonenum: "",
      password: "",
      countryArr:[],
      selCountry:{},
      isTgWebApp: false,
    };
  },
  computed: {
    bindmodel() {
        const { phonenum, password } = this;
        return {
          phonenum,
          password,
        };
      },
  },
   watch: {
      bindmodel: {
        handler: function ({phonenum, password}) {
          if(phonenum.length<6||password.length<6){
            this.formIsTrue = false;
          }else{
            this.formIsTrue = true;
          }
        },
      },
    },
  mounted() {
    this.isTgWebApp = isTelegramWebApp(this.$route);
    _self = this;
   // this.thisLang = this.getLang1(2);
    let a = localStorage.getItem('selcountry');
    console.log(a);
    if(a){
      _self.selCountry = JSON.parse(a);
      localStorage.setItem('selcountry','');
    }else{
      _self.getCountryMsg()
    }
  },
  methods: {
    phoneLogin(){
      this.$emit('isPhoneLogin', true)
    },

    emailLogin(){
      this.$emit('isEmailLogin', true)
    },
    //去选择国家/地区
    selAreaFun(){
      _self.$router.push({
        name: 'selArea'
      })
    },
    goLogin(){
      //console.log(11);
      this.confirmLogin(3,{
          "mobile": _self.phonenum,
          "password":_self.password
        });
    },
    //获取当前国家code
    getAreaCode() {

      let language = navigator.language || navigator.browserLanguage;
      let thisCounty = "";
      if (language.split("-")[1]) {
        thisCounty = language.split("-")[1];
      } else {
        thisCounty = language.split("-")[0];
      }
      let a = thisCounty.toUpperCase();
      let countryCode = a;
      // console.log(a);
      switch (a) {
        case "ZH":
          countryCode = "CN";
        case "EN":
          countryCode = "GB";
          break;
        case "KO":
          countryCode = "KR";
          break;
        case "RHK":
          countryCode = "HK";
          break;
        case "JA":
          countryCode = "JP";
          break;
        case "VI":
          countryCode = "VN";
          break;
        default:
          countryCode = a;
          break;
      }
      return countryCode;
    },
    getCountryMsg() {
      getCountryMsgAjax(_self.getAreaCode()).then(({ data}) => {
        if (data.code == 1) {
          this.selCountry = data.data;
        }
      }).catch((error) => {
        console.log(error);
      });
      return;
      this.$axios({
        method: "post",
        url: "/api/Country/getCountryMsg",
        params: {
          phone_country: _self.getAreaCode(),
        },
      })
    },
    selCountryInfo(e) {
      _self.selCountry = e;
      this.showCountry = false;
    },

  },
};
</script>
<style scoped>
.btn_split {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.67rem;
  margin-bottom: 0.3rem;
}
.btn_split_line {
  width: 0.88rem;
  height: 1px;
  background-color: #F3F3F3;
}
.btn_split_txt {
  color: #999;
  font-size: 0.26rem;
  padding: 0 0.3rem;
}
.login_other {
  display: flex;
  justify-content: center;
  align-items: center;
}

.countryList .van-icon__image{
    float: left;
    margin-top: .2em;
}
.form_box{
  margin: .64rem;
}
  .form_item{
    display: flex;
    height: 1.14rem;
    align-items: center;
    border-bottom: 1px solid #F3F3F3;
  }
  .flag_icon{
    width: .28rem;
    height: .28rem;
  }
  .form_input{
    flex: 1;
    width: auto;
    height: .6rem;
    border: none;
    padding-left: .3rem;
  }
  .form_icon{
    height: .34rem;

  }
  .select_icon{
    width: .14rem;
    height: .14rem;
  }
input::-ms-input-placeholder {
  font-size: 0.32rem;
  color: #ddd;
}
input::-webkit-input-placeholder {
  font-size: 0.32rem;
  color: #ddd;
}
.sendcode_img{
  width: .42rem;
}
.sendcode_btn {
  padding: 0.1rem 0.3rem;
  height: 0.44rem;
  line-height: 0.44rem;
  background-color: #d8d8d8;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
}
.sendcode_btn.active{
  background-color: #1fc3ff;
}
.countdown_btn{
  padding: 0.1rem .3rem;
  display: inline-block;
  font-size: 0.32rem;
  border: 1px solid #F3F3F3;
  color: #999;
  border-radius: 1rem;
  text-align: center;
}
.fc-bind-btn{
  padding: .2rem 0;
  display: block;
  margin: 2rem .8rem 0;
  font-size: .32rem;
  background-color: #d8d8d8;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
}
.fc-bind-btn.active{
  background-color: #008aff;
}

.selcountry_title{
  height: .88rem;
  line-height: .88rem;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 99;
  background-color: #fff;
  text-align: center;

}
.countryList{
  height: 100%;
  padding-top: .88rem;
  box-sizing: border-box;
  overflow: scroll;
}
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
.login-phone-bondo {
  margin-top: 2.49rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bondo-form_item {
  box-sizing: border-box;
  width: 5.97rem;
  height: 0.875rem;
  border-radius: 3.64rem;
  background-color: #292A28;
  display: flex;
  align-items: center;
  padding: 0 0.36rem;
}
.bondo-form__phone {
  margin-bottom: 0.31rem;
}
.bondo-phone-left {
  height: 100%;
  display: flex;
  align-items: center;
}
.bondo-phone-left::after {
  content: "";
  display: inline-block;
  border-left: 2px solid rgba(255, 255, 255, 0.10);
  height: 0.444rem;
  margin-left: 0.31rem;
}
.ar .bondo-phone-left::after {
  border-left: unset !important;
  margin-left: unset !important;
  border-right: 2px solid rgba(255, 255, 255, 0.10) !important;
  margin-right: 0.31rem !important;
}
.bondo-flag_icon {
  width: .28rem;
  height: .28rem;
  display: block;
}
.bondo-phone__code {
  margin-left: 0.1rem;
  color: #FFF;
  font-size: 0.278rem;
  font-style: normal;
  font-weight: 500;
  line-height: 0.76rem;
  display: flex;
  align-items: center;
}
.ar .bondo-phone__code {
  margin-left: unset !important;
  margin-right: 0.1rem !important;
}
.bondo-phone__down {
  margin-left: 0.1rem;
}
.ar .bondo-phone__down {
  margin-left: unset !important;
  margin-right: 0.1rem !important;
}
.bondo-phone-right {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  margin-left: 0.292rem;
}
.ar .bondo-phone-right {
  margin-left: unset !important;
  margin-right: 0.292rem !important;
}
.bondo__input {
  width: 100%;
  height: 0.417rem;
  font-size: 0.306rem;
  background-color: inherit;
  border: none;
  color: #FFF;
  caret-color: #FFF;
}
.bondo__input::placeholder {
  color: #9A9E95;
  font-size: 0.306rem;
}
.bondo-pwd__visible {
  margin-left: auto;
  width: 0.3194rem;
  height: 0.1528rem;
  padding-left: 0.31rem;
}
.ar .bondo-pwd__visible {
  padding-left: unset !important;
  padding-right: 0.31rem !important;
}
.bondo-other {
  width: 100%;
  height: 0.764rem;
  margin-top: 0.569rem;
}
.bondo-other__img {
  display: block;
  width: 0.764rem;
  height: 100%;
  margin: auto;
}
.bondo-login {
  margin-top: 0.917rem;
  width: 5.97rem;
  height: 0.875rem;
  border-radius: 0.444rem;
  background-color: #ADFF2F;
  color: #17191A;
  opacity: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bondo-login__active {
  opacity: 0.9;
}

.bondo__input:-webkit-autofill,
.bondo__input:-webkit-autofill:hover,
.bondo__input:-webkit-autofill:focus,
.bondo__input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #292A28 inset !important;
  -webkit-text-fill-color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Login/LoginPhone.vue